export class Search {
	static readonly type = '[brokerageSearch] search';
	constructor(public searchTerm: string) {}
}

export class Reset {
	static readonly type = '[brokerageSearch] reset';
}
